import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'dark' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
  children: React.ReactNode;
  className?: string;
}
export function Button({
  variant = 'primary',
  size = 'md',
  href,
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-body font-medium transition-colors duration-300 rounded-sm';
  const variants = {
    primary: 'bg-brand-gold text-brand-charcoal hover:bg-brand-gold-light',
    secondary: 'bg-transparent border border-brand-green text-brand-green hover:bg-brand-green hover:text-brand-cream-light',
    dark: 'bg-brand-green text-brand-cream-light hover:bg-brand-green-deep',
    ghost: 'bg-transparent text-brand-charcoal hover:text-brand-gold'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  const MotionComponent = motion.button;
  if (href) {
    return <Link to={href} className={combinedClassName} data-id="element-354">
        {children}
      </Link>;
  }
  return <MotionComponent whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={combinedClassName} {...props} data-id="element-355">
      {children}
    </MotionComponent>;
}